<template>
	<v-list-group
		v-if="userHasPermission"
		:group="group"
		:prepend-icon="item.icon"
		:sub-group="subGroup"
		append-icon="mdi-menu-down"
		:color="textColor"
		@click="onGroupClick()"
	>
		<template v-slot:activator>
			<v-list-item-icon
				v-if="text"
				class="v-list-item__icon--text"
				v-text="computedText"
			/>
			<v-list-item-content>
				<v-list-item-title v-text="item.title" />
			</v-list-item-content>
		</template>

		<div
			@click="onItemClick()"
			v-for="(child, i) in children"
			:key="`item-${i}`"
			class="pl-3"
		>
			<base-item-sub-group v-if="child.children" :item="child" />
			<item-anchor v-else-if="child.to" :item="child" text />
			<list-item v-else :item="child" text />
		</div>
	</v-list-group>
</template>

<script>
// Utilities
import ListItem from '@/components/base/ListItem';
import ItemAnchor from '@/components/base/ItemAnchor';
import BaseItemSubGroup from '@/components/base/ItemSubGroup';
import permissionsMixin from '@/mixins/permissionsMixin';

export default {
	name: 'ItemGroup',
	components: {
		ListItem,
		ItemAnchor,
		BaseItemSubGroup,
	},
	mixins: [permissionsMixin],
	inheritAttrs: false,

	props: {
		item: {
			type: Object,
			default: () => ({
				avatar: undefined,
				group: undefined,
				title: undefined,
				children: [],
				permissionsNeeded: [],
			}),
		},
		subGroup: {
			type: Boolean,
			default: false,
		},
		text: {
			type: Boolean,
			default: false,
		},
		textColor: String,
	},

	computed: {
		userHasPermission() {
			if (!this.item.permissionsNeeded?.length) return true;

			return this.hasPermissions(this.item.permissionsNeeded);
		},
		children() {
			return this.item.children.map((item) => ({
				...item,
				to: !item.to ? undefined : `${this.item.group}/${item.to}`,
			}));
		},
		computedText() {
			if (!this.item || !this.item.title) return '';

			let text = '';

			this.item.title.split(' ').forEach((val) => {
				text += val.substring(0, 1);
			});

			return text;
		},
		group() {
			return this.genGroup(this.item.children);
		},
	},

	methods: {
		onGroupClick() {
			this.$emit('groupClick');
		},
		onItemClick() {
			this.$emit('itemClick');
		},
		genGroup(children) {
			return children
				.filter((item) => item.to)
				.map((item) => {
					const parent = item.group || this.item.group;
					let group = `${parent}/${item.to}`;

					if (item.children) {
						group = `${group}|${this.genGroup(item.children)}`;
					}

					return group;
				})
				.join('|');
		},
	},
};
</script>

<style>
.v-list-group__activator p {
	margin-bottom: 0;
}
</style>
